import { CSSVariablesResolver } from '@mantine/core';
import { uiTokens } from './tokens.ts';

const resolver: CSSVariablesResolver = (_) => ({
  variables: {
    '--velos-brand-blue': uiTokens.brand.blue,
    '--velos-brand-pink': uiTokens.brand.pink,
    '--velos-brand-pink-dark': uiTokens.brand.pinkDark,
  },
  light: {},
  dark: {},
});

export default resolver;
